/* eslint-disable no-dupe-keys */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import Table from "../../EntryFile/datatable";
import Tabletop from "../../EntryFile/tabletop"
import { Link } from "react-router-dom";
import Select2 from "react-select2-wrapper";
import "react-select2-wrapper/css/select2.css";
import Swal from "sweetalert2";

import AuthUser from "../../components/AuthUser";
import { toast, ToastContainer } from 'react-toastify';
import Spinner from "../../components/Spinner";

// Importe o componente Datatable corretamente
import Datatable from "../../EntryFile/datatable";

import generatePDF from "../../components/export/generatePDF";
import generateExcel from "../../components/export/generateExcel";

import {
  ClosesIcon,
  Excel,
  Filter,
  Pdf,
  PlusIcon,
  Printer,
  Search,
  EditIcon,
  DeleteIcon,
  Thomas,
  Benjamin,
  James,
  Bruklin,
  Beverly,
  search_whites,
} from "../../EntryFile/imagePath";
import { User, UserPlus } from "react-feather";

import { format } from 'date-fns';

import PropTypes from 'prop-types';

const FormadorLists = ({ permissaoVer, permissaoAtivar, permissaoRemover, permissaoAtualizar }) => {

  const { http, url_root, logoTipo } = AuthUser();
  const [utilizadores, setUtilizador] = useState([]);

  const [funcaos, setFuncao] = useState([]);

  const [inputfilter, setInputfilter] = useState(false);

  const [tableHeader, setTableHeader] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [ficheiroNome, setFicheiroNome] = useState('');

  const [nomeFilter, setNomeFilter] = useState('');
  const [telefoneFilter, setTelefoneFilter] = useState('');
  const [emailFilter, setEmailFilter] = useState('');
  const [estadoFilter, setEstadoFilter] = useState(-1);
  const [data1Filter, setData1Filter] = useState('');
  const [data2Filter, setData2Filter] = useState('');
  const [generoFilter, setGeneroFilter] = useState(-1);

  const [localizacoes, setLocalizacoes] = useState([]);  
  const [localizacaoSelecionada, setLocalizacaoSelecionada] = useState(-1);
  const [funcaoSelecionada, setFuncaoSelecionada] = useState(-1);


  const [senhaUserId, setResetSenhaUserId] = useState(null);

  // State to track whether the "checkgeral" checkbox is checked
  const [loading, setLoading] = useState(false);

  const [selectedUserIds, setSelectedUserIds] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Chama a função assíncrona getFormador()
        await getFormador();

      } catch (error) {
        console.error('Erro ao obter utilizadores:', error);
      }
    };

    // Chama a função fetchData() para iniciar o processo
    fetchData();
  }, []);




  const handleFilterSubmit = async () => {
    try {

      setLoading(true);

      // Envie uma solicitação para pesquisar usuario
      const formData = new FormData();
      formData.append('nome', nomeFilter);
      formData.append('data1', data1Filter);
      formData.append('data2', data2Filter);
      formData.append('telefone', telefoneFilter);
      formData.append('email', emailFilter);
      formData.append('estado', estadoFilter);
      formData.append('nacionalidade', localizacaoSelecionada);
      formData.append('funcao_id', funcaoSelecionada);
      formData.append('genero', generoFilter);

      const response = await http.post('/utilizador/pesquisar_formador', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });

      //console.log(response.data.users);

      // Atualize a lista de utilizadores após resetar a senha
      setUtilizador(response.data.formadores);

      setLoading(false);

    } catch (error) {
      // Exiba uma mensagem de erro se ocorrer um problema
      toast.error('Ocorreu um erro pesquisar. Por favor, tente novamente mais tarde.', {
        position: 'top-right',
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });

      setLoading(false);

    }
  };

  const handleChechboxSelectionIds = (selectedRowKeys) => {
    setSelectedUserIds(selectedRowKeys);
  };

  const handleEliminarMultiplos = async () => {

    if (permissaoRemover) {

      // Exibe a mensagem de confirmação
      Swal.fire({
        title: "Tem certeza que quer eliminar ?",
        text: "Acção de eliminar utilizadores é irreversivel, pretende continuar.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sim, eliminar!",
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            // Envie uma solicitação para a API para eliminar os usuários selecionados
            const response = await http.post('/utilizador/eliminar-multiple', {
              selectedUserIds,
            });

            getFormador();

            toast.success(response.data.message, {
              position: 'top-right',
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
            });
          } catch (error) {
            console.error(error);

            toast.error('Ocorreu um erro ao eliminar os usuários. Por favor, tente novamente mais tarde.', {
              position: 'top-right',
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
            });


          }
        }
      });

    } else {
      Swal.fire({
        title: "SEM PERMISSÃO",
        text: "Lamento, mas não tem permissão para realizar esta operação, contacte o administrador do sistema",
        type: "error",
        showCancelButton: !0,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Certo, entendi!",
        confirmButtonClass: "btn btn-primary",
        cancelButtonClass: "btn btn-danger ml-1",
        buttonsStyling: !1,
      });
    }
  };


  const handleSelectedItemChange = async (newState) => {
    if (permissaoAtivar) {
      try {

        // Envie uma solicitação para a API para ativar/desativar os usuários selecionados
        const response = await http.post('/utilizador/activate-multiple', {
          selectedUserIds,
          newState,
        });

        getFormador();

        toast.success(response.data.message, {
          position: 'top-right',
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });

      } catch (error) {
        console.error(error);

        toast.error('Ocorreu um erro ao atualizar o estado dos usuários. Por favor, tente novamente mais tarde.', {
          position: 'top-right',
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });

      } finally {
        setLoading(false);
        // Limpe o estado dos IDs dos usuários selecionados
      }
    } else {
      Swal.fire({
        title: "SEM PERMISSÃO",
        text: "Lamento, mas não tem permissão para realizar esta operação, contacte o administrador do sistema",
        type: "error",
        showCancelButton: !0,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Certo, entendi!",
        confirmButtonClass: "btn btn-primary",
        cancelButtonClass: "btn btn-danger ml-1",
        buttonsStyling: !1,
      });
    }
  };

  const handleResetSenha = (id) => {

    if (permissaoAtualizar) {
      // Armazena o ID do usuário no estado resetSenhaUserId
      setLoading(true);

      // Exibe a mensagem de confirmação
      Swal.fire({
        title: "Tem certeza que quer resetar a senha?",
        text: "Isso irá resetar a senha do usuário.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sim, resetar senha!",
      }).then((result) => {
        if (result.isConfirmed) {
          // Se o usuário confirmar, envie a solicitação para resetar a senha
          resetarSenha(id);
          setLoading(false);
        } else {
          // Se o usuário cancelar, limpe o estado resetSenhaUserId
          setResetSenhaUserId(null);
          setLoading(false);
        }
      });

    } else {
      Swal.fire({
        title: "SEM PERMISSÃO",
        text: "Lamento, mas não tem permissão para realizar esta operação, contacte o administrador do sistema",
        type: "error",
        showCancelButton: !0,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Certo, entendi!",
        confirmButtonClass: "btn btn-primary",
        cancelButtonClass: "btn btn-danger ml-1",
        buttonsStyling: !1,
      });
    }
  };

  const resetarSenha = async (id) => {
    if (permissaoAtualizar) {
      try {
        // Gere uma senha aleatória no cliente
        const senhaAleatoria = Math.random().toString(36).slice(-8);

        // Exiba a senha antes de enviar a solicitação
        alert(`Nova Senha: ${senhaAleatoria}`);

        // Envie uma solicitação para a API para resetar a senha
        const response = await http.post(`/resetar-senha/${id}`, { novaSenha: senhaAleatoria });


        // Exiba uma mensagem de sucesso
        toast.success(response.data.message, {
          position: 'top-right',
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });

        // Atualize a lista de utilizadores após resetar a senha
        getFormador();

      } catch (error) {
        // Exiba uma mensagem de erro se ocorrer um problema
        toast.error('Ocorreu um erro ao resetar a senha. Por favor, tente novamente mais tarde.', {
          position: 'top-right',
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });

        setLoading(false);
      }
    } else {
      Swal.fire({
        title: "SEM PERMISSÃO",
        text: "Lamento, mas não tem permissão para realizar esta operação, contacte o administrador do sistema",
        type: "error",
        showCancelButton: !0,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Certo, entendi!",
        confirmButtonClass: "btn btn-primary",
        cancelButtonClass: "btn btn-danger ml-1",
        buttonsStyling: !1,
      });
    }
  };

  const getFormador = async () => {
    try {
      setLoading(true); // Set loading to true when the request starts

      const res = await http.get('/utilizadores/formadores');

      setUtilizador(res.data.utilizadores);

      const res2 = await http.get('/funcaos');

      setFuncao(res2.data.funcaos);

      const resultado2 = await http.get('/paises');

      setLocalizacoes(resultado2.data.regioes);

      setLoading(false);


      /* PDF E EXCEL */

      // Verifica se o array de utilizadores está vazio antes de prosseguir
      if (utilizadores.length === 0) {
        console.warn('Array de utilizadores vazio.');
        return;
      }

      const data = utilizadores?.map((utilizador) => ({
        name: utilizador.name,
        email: utilizador.email,
        telefone: utilizador.telefone,
        nivel: utilizador.nivel ? utilizador.nivel.designacao : '',
        estado: utilizador.estado === 1 ? 'Ativo' : 'Desativado',
      }));

      // Preenche os valores no estado após a conclusão de getFormador()
      setTableData(data);

      // Preenche outros estados conforme necessário
      setTableHeader(['Nome', 'Email', 'Telefone', 'Nível', 'Estado']);
      setFicheiroNome('utilizadores');



    } catch (error) {
      if (error.response && error.response.status === 401) {
        console.log('Utilizador não autenticado.');
      } else {
        console.log('Ocorreu um erro inesperado. Por favor, tente mais tarde.');
      }

      setLoading(false);
    } finally {
      setLoading(false); // Set loading to false when the request is complete (either success or error)
    }
  };

  const renderOptionsLocalizacoes = (regions) => {
    return regions?.map((region) => (
      <React.Fragment key={region?.id}>
        <option value={region?.id}>{region?.nome}</option>
        {region?.children && region?.children.length > 0 && renderOptionsLocalizacoes(region?.children)}
      </React.Fragment>
    ));
  };

  const renderOptionsFuncoes = (regions) => {
    return regions?.map((region) => (
      <React.Fragment key={region?.id}>
        <option value={region?.id}>{region?.designacao}</option>
      </React.Fragment>
    ));
  };

  const handleSelectLocalizacaoChange = (id) => {

    setLocalizacaoSelecionada(id);

  };

  const handleSelectFuncaoChange = (id) => {

    setFuncaoSelecionada(id);

  };

  const confirmEliminar = (id) => {

    if (permissaoRemover) {

      Swal.fire({
        title: "Tem a certeza que quer remover?",
        text: "Não sera possivel reverter o processo!",
        type: "warning",
        showCancelButton: !0,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sim, remover!",
        confirmButtonClass: "btn btn-primary",
        cancelButtonClass: "btn btn-danger ml-1",
        buttonsStyling: !1,
      }).then(function (t) {

        if (t.isConfirmed) {
          // Se o usuário confirmar, envie a solicitação
          handleEliminar(id);

        }


        /*t.value &&
          Swal.fire({
            type: "success",
            title: "Eliminado!",
            text: "Registo removido",
            confirmButtonClass: "btn btn-success",
          });*/

      });

    } else {
      Swal.fire({
        title: "SEM PERMISSÃO",
        text: "Lamento, mas não tem permissão para realizar esta operação, contacte o administrador do sistema",
        type: "error",
        showCancelButton: !0,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Certo, entendi!",
        confirmButtonClass: "btn btn-primary",
        cancelButtonClass: "btn btn-danger ml-1",
        buttonsStyling: !1,
      });
    }
  };

  const togglefilter = (value) => {
    setInputfilter(value);

    if (!value) {

      setNomeFilter('');
      setTelefoneFilter('');
      setEmailFilter('');
      setEstadoFilter();

      getFormador();

    }

  };


  const handleAtivarDesativar = async (id, newState) => {
    if (permissaoAtivar) {
      try {

        const estado = newState ? 1 : 0;

        const formData = new FormData();
        formData.append('id', id);
        formData.append('estado', estado);

        const response = await http.post('/utilizador/activate', formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
        });

        getFormador();

        toast.success(response.data.message, {
          position: 'top-right',
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });



        // Atualize a lista de utilizadores após ativar/desativar

      } catch (error) {
        console.error(error);

        toast.error('Ocorreu um erro ao atualizar o estado do usuário. Por favor, tente novamente mais tarde.', {
          position: 'top-right',
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });

      }
    } else {
      Swal.fire({
        title: "SEM PERMISSÃO",
        text: "Lamento, mas não tem permissão para realizar esta operação, contacte o administrador do sistema",
        type: "error",
        showCancelButton: !0,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Certo, entendi!",
        confirmButtonClass: "btn btn-primary",
        cancelButtonClass: "btn btn-danger ml-1",
        buttonsStyling: !1,
      });
    }
  };

  const handleEliminar = async (id) => {
    if (permissaoRemover) {
      try {



        const formData = new FormData();
        formData.append('id', id);

        const response = await http.post('/utilizador/eliminar', formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
        });

        getFormador();

        toast.success(response.data.message, {
          position: 'top-right',
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });



        // Atualize a lista de utilizadores após ativar/desativar

      } catch (error) {
        console.error(error);

        toast.error('Ocorreu um erro ao eliminar o estado do usuário. Por favor, tente novamente mais tarde.', {
          position: 'top-right',
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });



      } finally {
        setLoading(false);
      }
    } else {
      Swal.fire({
        title: "SEM PERMISSÃO",
        text: "Lamento, mas não tem permissão para realizar esta operação, contacte o administrador do sistema",
        type: "error",
        showCancelButton: !0,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Certo, entendi!",
        confirmButtonClass: "btn btn-primary",
        cancelButtonClass: "btn btn-danger ml-1",
        buttonsStyling: !1,
      });
    }
  };

  const situacoesOptions = [
    { value: "1", description: "Candidato Submetido" },
    { value: "2", description: "Currículo Avaliado" },
    { value: "3", description: "Contato Feito" },
    { value: "4", description: "Reunião Agendada" },
    { value: "5", description: "Entrevistado - Primeira Etapa" },
    { value: "6", description: "Entrevistado - Segunda Etapa" },
    { value: "7", description: "Avaliação Técnica" },
    { value: "8", description: "Referências Verificadas" },
    { value: "9", description: "Oferta Enviada" },
    { value: "10", description: "Oferta Aceita" },
    { value: "11", description: "Contratado" },
    { value: "12", description: "Recusado" },
  ];

  const getSituacaoDescription = (value) => {
    const situacao = situacoesOptions.find(option => option.value == value);
    return situacao ? situacao.description : '';
  };

  const columns = [
    {
      title: "Fotografia",
      dataIndex: "fotografia",
      render: (text, record) => (
        <div className="productimgname">
          <Link to={`/dream-pos/users/newformadoredit/${record.id}`} style={{ width: "70%" }} className="product-img">
            <img alt="fotografia" className="rounded-3" src={url_root + "/storage/" + record.fotografia} style={{ maxWidth: "50px" }} />
          </Link>

          <a title="Resetar a senha deste utilizador" className="" onClick={() => handleResetSenha(record.id)}>
            <i className="fa fa-key"></i>
          </a>

        </div>
      ),
      width: "80px",
    },
    {
      title: "Nome",
      dataIndex: "name",
      sorter: (a, b) => a.name.length - b.name.length,
    },
    {
      title: "Telefone/Email",
      dataIndex: "telefone", // Substituir por o nome do campo correto da API
      render: (e, record) => (
        <>
          <div className="">
            <div>{record?.telefone}</div>
            <div>[ {record?.email} ] </div>
          </div>

        </>
      ),
    },
    {
      title: "Funções",
      dataIndex: "funcoes",
      render: (text, record) => (
        <>
          {record?.funcoes?.map((cdata, index) => (
            <div key={index}>
              {FuncaoDaId(cdata.funcao_id)?.designacao}
            </div>
          ))}
        </>
      ),
    },
    {
      title: "Disponibilidade",
      dataIndex: "disponibilidade_data", // Substituir por o nome do campo correto da API
      render: (e, record) => (
        <>

          <div className="">
            <div>{format(new Date(record?.disponibilidade_data), 'dd/MM/yyyy')}</div>
            <div>[ {record?.disponibilidade_hora1.substring(0, 5)} - {record?.disponibilidade_hora2.substring(0, 5)} ]</div>
          </div>

        </>
      ),
    },
    {
      title: "Nacionalidade",
      dataIndex: "nacionalidade", // Substituir por o nome do campo correto da API
      sorter: (a, b) => a.nacionalidade?.nome?.length - b.nacionalidade?.nome?.length,
      render: (text, record) => record?.nacionalidade?.nome,
    },
    {
      title: "Situação",
      dataIndex: "situacao", // Substituir por o nome do campo correto da API
      render: (text, record) => (
        <>
          <div className="">
            <div>
              {getSituacaoDescription(record?.situacao)}
            </div>
          </div>
        </>
      ),
    },
    {
      title: "Ação",
      render: (e, record) => (
        <>

          <div className="icons-container">
            <Link title="editar dados utilizador" className="me-3" to={`/dream-pos/users/newformadoredit/${record.id}`}>
              <img src={EditIcon} alt="Editar" />
            </Link>

            <div title="Eliminar este utilizador" className="confirm-text" onClick={() => confirmEliminar(record.id)}>
              <img src={DeleteIcon} alt="Remover" />
            </div>
          </div>

        </>
      ),
    },
  ];

  const FuncaoDaId = (funcao_id) => {

    const funcaoEncontrado = funcaos?.find((lista) => lista.id == funcao_id);

    // Verifique se o objeto foi encontrado
    if (funcaoEncontrado != undefined) {
      return funcaoEncontrado;
    } else {
      // Caso não seja encontrado, você pode retornar null ou fazer algo diferente, dependendo do seu caso
      return null;
    }

  }

  if (permissaoVer)
    return (
      <>
        return (
        <>
          <div className="page-wrapper">
            <div className="content">
              <div className="page-header">
                <div className="titles">
                  <i alt="Image" className="header-image fa fa-users border p-3 rounded-3"></i>
                  <div>
                    <h4>Gestão de candidaturas</h4>
                    <h6>Lista de candidatos</h6>
                  </div>
                </div>
                <div className="page-btn">
                  <Link to="/dream-pos/users/newformador" className="btn btn-added">
                    <img src={PlusIcon} alt="img" className="me-1" />
                    Adicionar candidato
                  </Link>
                </div>
              </div>
              {/* /product list */}
              <div className="card">
                <div className="card-body">

                  <Tabletop inputfilter={inputfilter}
                    togglefilter={togglefilter}
                    handleSelectedItemChange={handleSelectedItemChange}
                    handleEliminarMultiplos={handleEliminarMultiplos}
                    generatePDF={generatePDF}
                    generateExcel={generateExcel}
                    logoTipo={logoTipo}
                    tableHeader={tableHeader}
                    tableData={tableData}
                    ficheiroNome={ficheiroNome}
                    setNomeFilter={setNomeFilter}
                    handleFilterSubmit={handleFilterSubmit}
                  />

                  {/* /Filter */}
                  <div
                    className={`card mb-0 ${inputfilter ? "toggleCls" : ""}`}
                    id="filter_inputs"
                    style={{ display: inputfilter ? "block" : "none" }}
                  >
                    <div className="card-body pb-0">
                      <div className="row">
                      <div className="col-lg-2 col-sm-6 col-12">
                        <div className="form-group" title="data 1">
                          <input type="date" className="form-control" placeholder="data1" value={data1Filter}
                            onChange={(e) => setData1Filter(e.target.value)} />
                        </div>
                      </div>
                      <div className="col-lg-2 col-sm-6 col-12" title="data 2">
                        <div className="form-group">
                          <input type="date" className="form-control" placeholder="data2" value={data2Filter}
                            onChange={(e) => setData2Filter(e.target.value)} />
                        </div>
                      </div>
                        <div className="col-lg-2 col-sm-6 col-12">
                          <div className="form-group">
                            <input type="text" placeholder="Nome" value={nomeFilter}
                              onChange={(e) => setNomeFilter(e.target.value)} />
                          </div>
                        </div>
                        <div className="col-lg-2 col-sm-6 col-12">
                          <div className="form-group">
                            <input type="text" placeholder="Telefone" value={telefoneFilter}
                              onChange={(e) => setTelefoneFilter(e.target.value)} />
                          </div>
                        </div>
                        <div className="col-lg-2 col-sm-6 col-12">
                          <div className="form-group">
                            <input type="text" placeholder="E-mail" value={emailFilter}
                              onChange={(e) => setEmailFilter(e.target.value)} />
                          </div>
                        </div>
                        <div className="col-lg-3 col-sm-6 col-12">
                          <div className="form-group">
                            <select
                              className="form-control select"
                              onChange={(e) => setEstadoFilter(e.target.value)}
                              value={estadoFilter}
                            >
                              <option value={-1}>
                                Todas as situações
                              </option>
                              {situacoesOptions.map((option) => (
                                <option key={option.value} value={option.value}>
                                  {option.description}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>

                        <div className="col-lg-3 col-sm-6 col-12">
                          <div className="form-group">
                            <select
                              name="nacionalidade_id"
                              onChange={(e) => handleSelectLocalizacaoChange(e.target.value)}
                              value={localizacaoSelecionada}
                              className="form-control select"
                            >
                              <option value={-1}>Todas as nacionalidades</option>
                              {renderOptionsLocalizacoes(localizacoes)}
                            </select>
                          </div>
                        </div>


                        <div className="col-lg-3 col-sm-6 col-12">
                          <div className="form-group">
                            <select
                              name="nacionalidade_id"
                              onChange={(e) => handleSelectFuncaoChange(e.target.value)}
                              value={funcaoSelecionada}
                              className="form-control select"
                            >
                              <option value={-1}>Todas as funções</option>
                              {renderOptionsFuncoes(funcaos)}
                            </select>
                          </div>
                        </div>

                        <div className="col-lg-3 col-sm-6 col-12">
                          <div className="form-group">
                            <select
                              className="form-control select"
                              onChange={(e) => setGeneroFilter(e.target.value)}
                              value={generoFilter}
                            >
                              <option value={-1}>
                                Ambos generos
                              </option>

                              <option value={2}>
                                Mulher
                              </option>

                              <option value={1}>
                                Homem
                              </option>

                            </select>
                          </div>
                        </div>

                        <div className="col-lg-1 col-sm-6 col-12 ms-auto">
                          <div className="form-group">
                            <a className="btn btn-filters ms-auto">
                              <img src={search_whites} alt="img" onClick={handleFilterSubmit} />
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* /Filter */}
                  <div className="table-responsive">

                    {loading ? (<span>Carregando...</span> // Render the spinner component when loading is true
                    ) : (

                      /*<Table columns={columns} dataSource={utilizadores} />*/

                      <Datatable
                        columns={columns}
                        dataSource={utilizadores}
                        onSelectedRowsChange={(selectedUserIds) =>
                          setSelectedUserIds(selectedUserIds)
                        }

                      />



                    )}

                  </div>
                </div>
              </div>
              {/* /product list */}
            </div>
          </div>

          <ToastContainer />

        </>
        ); </>
    );
  else
    return (<>
      <div className="page-wrapper cardhead">
        <div className="content ">
          {/* Page Header */}
          <div className="page-header">
            <div className="row">
              <div className="col-sm-12">
                <h3 className="page-title">SEM PERMISSÃO</h3>

              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-12">

              <div className="card">
                <div className="card-header">
                  <h4 className="card-title"><i className="fa fa-times-circle text-danger"></i>&nbsp; OPERAÇÃO NÃO AUTORIZADA</h4>
                </div>
                <div className="card-body">
                  <p>
                    Esta operação não é autorizada para o seu nivel de acesso ao sistema, por favor contacte o administrador do sistema.
                  </p>
                </div>
              </div>

            </div>
          </div>

        </div>
      </div>
    </>)
};

FormadorLists.propTypes = {
  permissaoVer: PropTypes.bool.isRequired,
  permissaoAtivar: PropTypes.bool.isRequired,
  permissaoRemover: PropTypes.bool.isRequired,
  permissaoAtualizar: PropTypes.bool.isRequired,
};

export default FormadorLists;
